import NativeInterface from "./NativeInterface"
import Geolocation from "../models/Geolocation";

export type GeoCallback = (location: Geolocation | null) => void;

class GeolocationService
{
    mLocation: Geolocation | null = null;
    mGeoCallbacks: GeoCallback[] = [];

    constructor() {
        //this.mLocation = new Geolocation("51.330017618292096 -0.26960362358452644 0 -1 -1");
        NativeInterface.registerCallback("updateGeolocation", (str: string) => {
            this.updateLocation(str ? new Geolocation(str) : null);
        });
        NativeInterface.requestGeolocationUpdate()
    }

    location() {
        return this.mLocation;
    }

    updateLocation(loc: Geolocation | null) {
        this.mLocation = loc;
        for (const callback of this.mGeoCallbacks) {
            callback(this.mLocation);
        }
    }

    subscribeOnUpdate(callback: GeoCallback) {
        this.mGeoCallbacks.push(callback);
        if (this.mLocation) {
            callback(this.mLocation)
        }
    }

    unsubscribeOnUpdate(callback: GeoCallback) {
        this.mGeoCallbacks = this.mGeoCallbacks.filter(item => item !== callback);
    }
}

const g_geolocation = new GeolocationService()
export default g_geolocation;
